import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import { useEffect, useState } from 'react';
import {
  AutocompleteInput, DateInput, TextInput, required, useNotify, useRecordContext,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { genreChoices, releaseTypeChoices } from '@/Helper/DropdownChoices/dropdownChoices';

type Country = {
  Abbreviation: string;
  Name: string;
};

function AlbumDetailsSection() {
  const record = useRecordContext();
  const notify = useNotify();
  const [countries, setCountries] = useState<Country[]>([]);
  const { getValues } = useFormContext();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get<Country[]>('/api/countries');
        setCountries(response.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    void fetchCountries();
  }, []);

  const countryChoices = countries.map((country) => ({
    id: country.Abbreviation,
    name: country.Name,
  }));

  const handleSearchSpotify = () => {
    const currentTitle = getValues().Title;

    if (!currentTitle) {
      notify('No album title available', { type: 'warning' });
      return;
    }
    const searchQuery = encodeURIComponent(currentTitle);
    window.open(`https://open.spotify.com/search/${searchQuery}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography variant='h6' gutterBottom>Album Details</Typography>

      <Box
        display='flex' gap={2}
        alignItems='flex-start'
      >
        <Box flex={1}>
          <TextInput
            source='Title'
            label='Title'
            fullWidth
            validate={required()}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<SearchIcon />}
          onClick={handleSearchSpotify}
          disabled={!record?.Title}
          sx={{ mt: 1 }}
        >
          Search on Spotify
        </Button>
      </Box>

      <DateInput
        source='ReleaseDate'
        label='Release Date'
        type='date'
        fullWidth
        sx={{ mt: 2 }}
        validate={required()}
      />

      <AutocompleteInput
        source='Country'
        label='Country'
        choices={countryChoices}
        fullWidth
        sx={{ mt: 2 }}
      />
      <AutocompleteInput
        source='Genre' label='Genre'
        choices={genreChoices} fullWidth
        sx={{ mt: 2 }}
      />
      <AutocompleteInput
        source='ReleaseType' label='Release Type'
        choices={releaseTypeChoices} readOnly
      />
    </Box>
  );
}

export default AlbumDetailsSection;
